<template>
         <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
            <template #item-content.1>
               <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'MAKLUMAT TERNAKAN'" >
                  <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
                  <template #title>
                     MAKLUMAT TERNAKAN
                     <w-flex justify-end class="mt2">
                        <w-button @click="isMinimizedList = !isMinimizedList">
                           <template v-if="isMinimizedList">
                              <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                           </template>
                           <template v-else>
                              <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                           </template>
                        </w-button>
                     </w-flex>
                  </template>
                  <div v-show="!isMinimizedList">
                  <div class="w-table-wrap" style="max-height: 400px;">
                     <div class="table-profil-scrol">
                        <table class="w-table" color="light" >
                           <thead>
                              <tr>
                                 <th class="w-table__header  text-center" width="1%">BIL</th>
                                 <th class="w-table__header  text-center">ID/ NAMA TERNAKAN</th>
                                 <th class="w-table__header  text-center">PEMERIKSAAN RESIPIEN</th>
                                 <th class="w-table__header  text-center">PROSEDUR SINKRONISASI</th>
                                <!--  <th class="w-table__header  text-center">PROSEDUR AI</th>
                                 <th class="w-table__header  text-center">PEMERIKSAAN KEBUNTINGAN</th>
                                 <template v-if="data.lkp_status_id==39 && data.juruteknik_pd_id ==0 && $zutil.anyRole(['1', '2'])">
                                    <th class="w-table__header  text-center">TINDAKAN</th>
                                 </template> -->
                              </tr>
                           </thead>
                           <tbody>
                              <template v-for="(dt, ind) in data.ternakan_list">
                                 <tr class="w-table__row" >
                                    <td class="w-table__cell text-left" >{{ind+1}}</td>
                                    <td class="w-table__cell text-left" ><div style="width:200px"></div>
                                       <a @click="detail(dt, 0)" style="text-decoration: underline;color: #3a3ad0;">{{dt.ternakan_nama}}</a></td>
                                    <td align="center">
                                       <template v-if="data.tarikh_pemeriksaan != null">
                                       <a @click="detail(dt, 1)" style="text-decoration: underline;color: #3a3ad0;">{{$zutil.dateformat(data.tarikh_pemeriksaan)}}</a>
                                       </template>
                                       <template v-else>-</template>
                                    </td>
                                    <td align="center">
                                       <template v-if="tarikh_sinkronisasi != null">
                                       <a @click="detail(dt, 2)" style="text-decoration: underline;color: #3a3ad0;">{{$zutil.dateformat(tarikh_sinkronisasi)}}</a>
                                       </template>
                                       <template v-else>-</template>
                                    </td>
                                   <!--  <td align="center">
                                       <template v-if="data.tarikh_ai != null">
                                       <a @click="detail(dt, 3)" style="text-decoration: underline;color: #3a3ad0;">{{$zutil.dateformat(data.tarikh_ai)}}</a>
                                       </template>
                                       <template v-else>-</template>
                                    </td>
                                    <td align="center">
                                       <template v-if="data.tarikh_pemeriksaan_art != null">
                                          <a @click="detail(dt, 4)" style="text-decoration: underline;color: #3a3ad0;">{{$zutil.dateformat(data.tarikh_pemeriksaan_art)}}</a>
                                       </template>
                                       <template v-else>-</template>
                                    </td>
                                    <template v-if="data.lkp_status_id==39 && data.juruteknik_pd_id ==0 && $zutil.anyRole(['1', '2'])">
                                       <td class="w-table__cell text-center"><div class="title4 mb2"></div><w-checkbox v-model="dt.pilih" :disabled="dt.lkp_status_id==28||dt.bunting==1"></w-checkbox></td>
                                    </template> -->
                                 </tr>
                              </template>
                           </tbody>
                        </table>
                     </div>
                  </div>
                  </div>
                  <w-flex class="mt3" wrap align-center justify-end v-if="data.lkp_status_id==39 && data.juruteknik_pd_id ==0 && $zutil.anyRole(['1', '2' , '5'])">
                     <w-button class="my1" type="submit" :disabled="loading" :loading="loading">
                         <w-icon xs class="mr2">fal fa-paper-plane</w-icon> Mohon Semula ET
                     </w-button>
                  </w-flex>
                  </w-form>
               </w-card>
               <br>
               <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'CAJ PERKHIDMATAN SINKRONISASI'" >
                  <template #title>
                     CAJ PERKHIDMATAN SINKRONISASI
                     <w-flex justify-end class="mt2">
                        <w-button @click="isMinimizedCajSinkron = !isMinimizedCajSinkron">
                           <template v-if="isMinimizedCajSinkron">
                              <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                           </template>
                           <template v-else>
                              <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                           </template>
                        </w-button>
                     </w-flex>
                  </template>
                  <div v-show="!isMinimizedCajSinkron">
                     <figure class="table-aims">
                         <figure class="table">
                             <table class="w-table">
                               
                                   <tbody>
                                       <tr>
                                           <td colspan="3"><strong>Tarikh / Perkhidmatan</strong></td>
                                           <td width="1px">:</td>
                                           <td colspan="2">{{$zutil.dateformat(tarikh_sinkronisasi)}}</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td align="right">
                                             <w-tooltip md top color="white" bg-color="black">
                                                <template #activator="{ on }">
                                                   <w-button class="ma1" v-on="on" bg-color="success" @click="cetakCaj(data.id)"><div style="width: 4px"></div> 
                                                      <w-icon class="mr1" md style="color: white;">fal fa-print</w-icon>
                                                   </w-button>
                                                </template>
                                                   Cetak Caj Perkhidmatan
                                             </w-tooltip>
                                           </td>
                                       </tr>
                                       <tr>
                                           <td width="1px"><b>1.</b></td>
                                           <td colspan="2"><strong>Konsultasi / Perkhidmatan</strong></td>
                                           <td>:</td>
                                           <td colspan="2">

                                                         <w-tag
                                                           class="mr4"
                                                           bg-color="primary"
                                                           round>
                                                            <template v-if="data.konsutasi_sinkronisasi_ya_tidak==1">Berbayar</template><template v-else>Subsidi</template>
                                                         </w-tag></td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td align="right">RM {{$zutil.formatDecimal(data.konsutasi_sinkronisasi)}}</td>
                                       </tr>
                                       <tr>
                                           <td><b>2.</b></td>
                                           <td colspan="2"><strong>Harga Hormon</strong></td>
                                           <td colspan="3"><strong>Harga (RM)</strong></td>
                                           <td>&nbsp;</td>
                                           <td><strong>Kuantiti</strong></td>
                                           <td colspan="2"><strong>Jumlah (RM)</strong></td>
                                       </tr>
                                       <tr>
                                           <td>&nbsp;</td>
                                           <td width="1px" class="text-center">i.</td>
                                           <td>Hormon CIDR</td>
                                           <td></td>
                                           <td colspan="2" align="right">
                                                <w-tag
                                                  class="mr4"
                                                  bg-color="primary"
                                                  round v-if="cidr.sinkronisasi_ya_tidak==1 || cidr.sinkronisasi_ya_tidak==2">
                                                    <template v-if="cidr.sinkronisasi_ya_tidak==1">Berbayar</template>
                                                    <template v-else-if="cidr.sinkronisasi_ya_tidak==2">Subsidi</template>
                                                </w-tag>
                                                RM {{$zutil.formatDecimal(cidr.harga)}}
                                           </td>
                                           <td>&nbsp;</td>
                                           <td>
                                               {{cidr.kuantiti}}
                                           </td>
                                           <td colspan="2" align="right">
                                              RM {{$zutil.formatDecimal(cidr.jumlah)}}
                                           </td>
                                       </tr>
                                       <tr>
                                           <td>&nbsp;</td>
                                           <td width="1px" class="text-center">ii.</td>
                                           <td>Hormon Prid Delta</td>
                                           <td>&nbsp;</td>
                                           <td colspan="2" align="right">
                                                <w-tag
                                                  class="mr4"
                                                  bg-color="primary"
                                                  round v-if="prid_delta.sinkronisasi_ya_tidak==1 || prid_delta.sinkronisasi_ya_tidak==2">
                                                    <template v-if="prid_delta.sinkronisasi_ya_tidak==1">Berbayar</template>
                                                    <template v-else-if="prid_delta.sinkronisasi_ya_tidak==2">Subsidi</template>
                                                </w-tag>
                                                RM {{$zutil.formatDecimal(prid_delta.harga)}}
                                           </td>
                                           <td>&nbsp;</td>
                                           <td>
                                                {{prid_delta.kuantiti}}
                                           </td>
                                           <td colspan="2" align="right">
                                                RM {{$zutil.formatDecimal(prid_delta.jumlah)}}
                                           </td>
                                       </tr>
                                       <tr>
                                           <td>&nbsp;</td>
                                           <td width="1px" class="text-center">iii.</td>
                                           <td>Hormon Tambahan</td>
                                           <td>&nbsp;</td>
                                           <td colspan="2" align="right">
                                                <w-tag
                                                  class="mr4"
                                                  bg-color="primary"
                                                  round v-if=" sinkronisasi_ya_tidak_subsidi > 0">
                                                    Subsidi
                                                </w-tag>
                                                <template v-if=" harga_persendirian_subsidi > 0">
                                                    RM {{$zutil.formatDecimal(harga_persendirian_subsidi)}}
                                                    <br>
                                                </template>
                                                <w-tag
                                                  class="mr4"
                                                  bg-color="primary"
                                                  round v-if=" sinkronisasi_ya_tidak_bayar > 0">
                                                    Berbayar
                                                </w-tag>
                                                <template v-if=" harga_persendirian_bayar > 0">
                                                    RM {{$zutil.formatDecimal(harga_persendirian_bayar)}}
                                                </template>
                                           </td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td colspan="2" align="right">
                                                <template v-if=" jumlah_persendirian_subsidi > 0">
                                                    RM {{$zutil.formatDecimal(jumlah_persendirian_subsidi)}}
                                                     <br>
                                                </template>
                                                <template v-if=" jumlah_persendirian_bayar > 0">
                                                    RM {{$zutil.formatDecimal(jumlah_persendirian_bayar)}}
                                                </template>
                                           </td>
                                       </tr>
                                       <tr>
                                           <td><b>3.</b></td>
                                           <td colspan="2"><strong>Caj Perjalanan (RM)</strong></td>
                                           <td>:</td>
                                           <td colspan="2" align="left">
                                              <w-tag
                                               class="mr4"
                                               bg-color="primary"
                                               round>
                                                <template v-if="data.bayar_pengangkutan==1">Berbayar</template>
                                                <template v-else>Subsidi</template>
                                             </w-tag>
                                            </td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td colspan="2" align="right"> 
                                                RM {{$zutil.formatDecimal(data.pengangkutan_sinkronisasi)}}</td>
                                       </tr>
                                       <tr>
                                           <td><b>4.</b></td>
                                           <td colspan="2"><strong>Caj Lain-Lain (Jika Ada)(RM)</strong></td>
                                           <td>:</td>
                                           <td align="left" colspan="2">
                                              <w-tag
                                               class="mr4"
                                               bg-color="primary"
                                               round>
                                                <template v-if="data.bayar_caj_lain==1">Berbayar</template><template v-else>Subsidi</template>
                                              </w-tag>
                                           </td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td colspan="2" align="right">
                                               RM {{$zutil.formatDecimal(data.caj_lain_sinkronisa)}}
                                           </td>
                                       </tr>
                                       <tr>
                                           <td><b></b></td>
                                           <td colspan="2">Nyatakan</td>
                                           <td>:</td>
                                           <td colspan="2">
                                                <template v-if="data.nyatakan_sinkronisa==null">-</template>
                                                <template v-else>{{data.nyatakan_sinkronisa}}</template>
                                            </td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td colspan="2" align="right"></td>
                                       </tr>
                                       <tr>
                                           <td colspan="3">&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                       </tr>
                                       <tr>
                                           <td colspan="3"><strong>Jumlah Caj Keseluruhan</strong></td>
                                           <td>:</td>
                                           <td colspan="2" align="left"><strong>RM {{$zutil.formatDecimal(data.keseluruhan_sinkronisasi)}}</strong></td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td colspan="2" align="right"></td>
                                        </tr>
                                        <tr>
                                           <td colspan="3"><strong>Jumlah Caj Subsidi Kerajaan</strong></td>
                                           <td>:</td>
                                           <td align="left" colspan="2"><strong>RM {{$zutil.formatDecimal(data.subsidi_sinkronisasi)}}</strong></td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td colspan="2" align="right"></td>
                                       </tr>
                                       <tr>
                                           <td colspan="3"><strong>Jumlah Caj Yang Perlu Dibayar</strong></td>
                                           <td>:</td>
                                           <td colspan="2" align="left"><strong>RM {{$zutil.formatDecimal(data.perlu_bayar_sinkronisasi)}}</strong></td>
                                           <td>&nbsp;</td>
                                           <td>&nbsp;</td>
                                           <td colspan="2" align="right"></td>
                                       </tr>
                                   </tbody>
                               </table>
                         </figure>
                     </figure>
                  </div>
               </w-card><br>
               <br>
               <w-flex justify-end class="mt2" v-if="$zutil.anyRole(['1', '2' , '5'])">
                  <!-- semakan perakuan 1 -->
                  <!-- <template v-if="data.lkp_status_id==35 && data.tarikh_pemeriksaan_art == null">
                     <w-button class="mr2" bg-color="success" @click="sahkan(39)">
                        <w-icon m class="mr2">fal fa-check-circle</w-icon>SAHKAN
                     </w-button>
                     <br>
                     <w-button class="mr2" bg-color="error" @click="semaksemula(27)">
                        <w-icon m class="mr2">fal fa-times-circle</w-icon>SEMAK SEMULA
                     </w-button>
                  </template> -->
                  <!-- semakan perakuan 2 -->
                  <template v-if="data.lkp_status_id==35">
                     <w-button class="mr2" bg-color="success" @click="sahkan(18)">
                        <w-icon m class="mr2">fal fa-check-circle</w-icon>SAHKAN
                     </w-button>
                     <br>
                     <w-button class="mr2" bg-color="error" @click="semaksemula(27)">
                        <w-icon m class="mr2">fal fa-times-circle</w-icon>SEMAK SEMULA
                     </w-button>
                  </template>
                  <!-- mohon pd -->
                  <!-- <template v-else-if="data.lkp_status_id==39 && data.juruteknik_pd_id==0">
                     <w-button class="mr2" bg-color="primary" @click="mohonPd(40)">
                        <w-icon m class="mr2">fal fa-paper-plane</w-icon>Mohon PD
                     </w-button>
                  </template> -->
                  <!-- <template v-else-if="data.lkp_status_id==40">
                     <w-button class="mr2" bg-color="success" @click="sahkan(18)">
                        <w-icon m class="mr2">fal fa-check-circle</w-icon>SAHKAN
                     </w-button>
                  </template> -->
                  <template v-else>
                     <br>
                  </template>
               </w-flex>
               <br>
            </template>
            <template #item-content.2>
               <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'AUDIT TRAIL'" >
                  <div class="w-table-wrap" style="max-height: 400px;">
                     <div class="table-profil-scrol">
                        <table class="w-table" color="light" >
                           <thead>
                              <tr>
                                <th class="w-table__header  text-center" width="1%">BIL</th>
                                <th class="w-table__header  text-center">USER</th>
                                <th class="w-table__header  text-center">STATUS</th>
                                <th class="w-table__header  text-center">REMARK</th>
                                <th class="w-table__header  text-center">TARIKH</th>      
                              </tr>
                           </thead>
                           <tbody>
                              <template v-for="(data, ind) in data.audit_trail">
                              <tr class="w-table__row" >
                                  <td class="w-table__cell text-center" >{{ind+1}}</td>
                                  <td class="w-table__cell text-center" >{{data.user}}</td>
                                  <td class="w-table__cell text-center" >{{data.status}}</td>
                                  <td class="w-table__cell text-center" >{{data.remark}}</td>
                                  <td class="w-table__cell text-center" >{{data.tarikh}}</td>
                                 </tr>
                              </template>
                           </tbody>
                        </table>
                     </div>
                  </div>
               </w-card>
            </template>
         </w-tabs>
         <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-dark1--bg white">
            <template #title>
               <w-icon class="mr2">fal fa-list</w-icon>
               {{dialog.item.ternakan_nama}}
            </template>
               <template v-if="dialog.tab==0">
                  <w-tabs :items="tabsModal" card v-model="activeTabModal">
                     <template #item-content.1>
                        <div class="w-flex wrap smd-column" >
                           <div class="grow " style="line-height: 35px">
                              <table >
                                 <tbody>
                                 <tr class="row_data">
                                    <td>Status Kesihatan</td>  
                                    <td>:</td>
                                    <td>{{dialog.item.lkp_status_kesihatan}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Skor Badan</td>  
                                    <td>:</td>
                                    <td>{{dialog.item.skor_badan}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Status Kebuntingan</td>  
                                    <td>:</td>
                                    <td><div v-if="dialog.item.bunting==1">Bunting</div><div v-else>Tidak Bunting</div></td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Usia Kebuntingan</td>  
                                    <td>:</td>
                                    <td>{{dialog.item.usia_bunting}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Tarikh Jangkaan Kelahiran</td>  
                                    <td>:</td>
                                    <td>{{$zutil.dateformatBulanTahun(dialog.item.jankaan_kelahiran)}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Catatan</td>  
                                    <td>:</td>
                                    <td>{{dialog.item.catatan}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Setatus Pemeriksaan</td>  
                                    <td>:</td>
                                    <td><template v-if="dialog.item.status_pemeriksaan==1">Lulus</template><template v-else>Tidak Lulus</template></td>
                                 </tr>
                                 </tbody>
                              </table>
                           </div>
                        </div>
                     </template>
                     <template #item-content.2>
                        <div v-if="dialog.item.sinkronisasi.length > 0">
                           <w-flex wrap class="ma-2">
                              <div v-for="(d, ind) in dialog.item.sinkronisasi" class="xs6 pa2">
                                 <div class="w-flex wrap smd-column" >
                                    <div class="grow " style="line-height: 35px">
                                       <table >
                                          <tbody>
                                          <tr class="row_data">
                                             <td><b>HORMON {{ind+1}}</b></td>  
                                             <td>:</td>
                                             <td>{{d.hormon}}</td>
                                          </tr>
                                          <template v-if="d.lkp_jenis_hormon_id == 3">
                                             <tr class="row_data">
                                                <td><b>Nama Hormon</b></td>  
                                                <td>:</td>
                                                <td>{{d.nama_hormon}}</td>
                                             </tr>
                                             <tr class="row_data">
                                                <td><b>Jenis Hormon</b></td>  
                                                <td>:</td>
                                                <td>{{d.jenis_hormon}}</td>
                                             </tr>
                                             <tr class="row_data">
                                                <td><b>Tarikh Hormon</b></td>  
                                                <td>:</td>
                                                <td>{{$zutil.dateformat(d.tarikh_hormon)}}</td>
                                             </tr>
                                             <tr class="row_data">
                                                <td><b>Kuantiti (ml)</b></td>  
                                                <td>:</td>
                                                <td>{{d.kuantiti_hormon}}</td>
                                             </tr>
                                             <tr class="row_data">
                                                <td><b>Harga (RM)</b></td>  
                                                <td>:</td>
                                                <td>RM. {{$zutil.currency(d.harga)}}</td>
                                             </tr>
                                          </template>
                                          <template v-else>
                                             <tr class="row_data">
                                                <td><b>Nama Hormon</b></td>  
                                                <td>:</td>
                                                <td>{{d.nama_hormon}}</td>
                                             </tr>
                                             <tr class="row_data">
                                                <td><b>Tarikh Masuk Suntik</b></td>  
                                                <td>:</td>
                                                <td>{{$zutil.dateformat(d.tarikh_masuk_suntik)}}</td>
                                             </tr>
                                             <tr class="row_data">
                                                <td><b>Tarikh Keluar Suntik</b></td>  
                                                <td>:</td>
                                                <td>{{$zutil.dateformat(d.tarikh_keluar_suntik)}}</td>
                                             </tr>
                                             <tr class="row_data">
                                                <td><b>Harga (RM)</b></td>  
                                                <td>:</td>
                                                <td>RM. {{$zutil.currency(d.harga)}}</td>
                                             </tr>
                                          </template>
                                          </tbody>
                                       </table>
                                    </div>
                                 </div>
                              </div>
                           </w-flex>
                        </div>
                        <div v-else><center>Tiada data.</center></div>
                     </template>
                     <!-- <template #item-content.3>
                        <div class="w-flex wrap smd-column" >
                           <div class="grow " style="line-height: 35px">
                              <table >
                                 <tr class="row_data">
                                    <td>No Kes AI</td>  
                                    <td>:</td>
                                    <td>{{dialog.item.no_kes}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Sumber Semen</td>  
                                    <td>:</td>
                                    <td>{{dialog.item.lkp_kategori_semen}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Jenis Semen</td>  
                                    <td>:</td>
                                    <td>{{dialog.item.jenis_semen_ket}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>ID Ternakan | No Batch Semen</td>  
                                    <td>:</td>
                                    <td>
                                       <div v-if="!dialog.item.no_batch_keterangan">
                                          {{dialog.item.id_ternakan}} | {{dialog.item.no_batch}}
                                       </div>
                                       <div v-else>
                                          {{dialog.item.no_batch_keterangan  }}
                                       </div>
                                    </td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Harga Semen</td>  
                                    <td>:</td>
                                    <td>{{$zutil.formatDecimal(dialog.item.harga_straw)}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>No. Inseminasi</td>  
                                    <td>:</td>
                                    <td>{{dialog.item.bil_inseminasi}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Bil. Straw Semen</td>  
                                    <td>:</td>
                                    <td>{{dialog.item.bil_straw}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Tarikh Jangkaan PD</td>  
                                    <td>:</td>
                                    <td>{{$zutil.dateformat(dialog.item.jankaan_biang_semula)}}</td>
                                 </tr>
                              </table>
                           </div>
                        </div>
                     </template>
                     <template #item-content.4>
                        <div class="w-flex wrap smd-column" >
                           <div class="grow " style="line-height: 35px">
                              <table >
                                 <tr class="row_data">
                                    <td>No Kes AI</td>  
                                    <td>:</td>
                                    <td>{{dialog.item.no_kes}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Baka</td>  
                                    <td>:</td>
                                    <td>{{dialog.item.baka}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Tarikh Beranak Terdahulu</td>  
                                    <td>:</td>
                                    <td>{{dialog.item.tarikh_beranak_terdahulu}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Tarikh Suntikan Terdahulu/ Nama Juruteknik/ Jurusuntik</td>  
                                    <td>:</td>
                                    <td>-</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Kaedah Pemeriksaan</td>  
                                    <td>:</td>
                                    <td>{{dialog.item.lkpKaedahPemeriksaan_keterangan}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Status</td>  
                                    <td>:</td>
                                    <td><div v-if="dialog.item.bunting_art==1">Bunting</div><div v-else>Tidak Bunting</div></td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Usia Kebuntingan</td>  
                                    <td>:</td>
                                    <td>{{dialog.item.usia_bunting_art}}</td>
                                 </tr>
                                 <tr class="row_data">
                                    <td>Tarikh Jangkaan Beranak</td>  
                                    <td>:</td>
                                    <td>{{$zutil.dateformat(dialog.item.jankaan_kelahiran_art)}}</td>
                                 </tr>
                              </table>
                           </div>
                        </div> 
                     </template> -->
                  </w-tabs>
               </template>
               <template v-if="dialog.tab==1">
                  <div class="w-flex wrap smd-column" >
                     <div class="grow " style="line-height: 35px">
                        <table >
                           <tbody>
                           <tr class="row_data">
                              <td>Status Kesihatan</td>  
                              <td>:</td>
                              <td>{{dialog.item.lkp_status_kesihatan}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>Skor Badan</td>  
                              <td>:</td>
                              <td>{{dialog.item.skor_badan}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>Status Kebuntingan</td>  
                              <td>:</td>
                              <td><div v-if="dialog.item.bunting==1">Bunting</div><div v-else>Tidak Bunting</div></td>
                           </tr>
                           <tr class="row_data">
                              <td>Usia Kebuntingan</td>  
                              <td>:</td>
                              <td>{{dialog.item.usia_bunting}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>Tarikh Jangkaan Kelahiran</td>  
                              <td>:</td>
                              <td>{{$zutil.dateformatBulanTahun(dialog.item.jankaan_kelahiran)}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>Catatan</td>  
                              <td>:</td>
                              <td>{{dialog.item.catatan}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>Setatus Pemeriksaan</td>  
                              <td>:</td>
                              <td><template v-if="dialog.item.status_pemeriksaan==1">Lulus</template><template v-else>Tidak Lulus</template></td>
                           </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
               </template>
               <template v-if="dialog.tab==2">
                  <div v-if="dialog.item.sinkronisasi.length > 0">
                     <w-flex wrap class="ma-2">
                        <div v-for="(d, ind) in dialog.item.sinkronisasi" class="xs6 pa2">
                           <div class="w-flex wrap smd-column" >
                              <div class="grow " style="line-height: 35px">
                                 <table >
                                    <tbody>
                                    <tr class="row_data">
                                       <td><b>HORMON {{ind+1}}</b></td>  
                                       <td>:</td>
                                       <td>{{d.hormon}}</td>
                                    </tr>
                                    <template v-if="d.lkp_jenis_hormon_id == 3">
                                       <tr class="row_data">
                                          <td><b>Nama Hormon</b></td>  
                                          <td>:</td>
                                          <td>{{d.jenis_hormon}}</td>
                                       </tr>
                                       <tr class="row_data">
                                          <td><b>Jenis Hormon</b></td>  
                                          <td>:</td>
                                          <td>{{d.jenis_hormon}}</td>
                                       </tr>
                                       <tr class="row_data">
                                          <td><b>Tarikh Hormon</b></td>  
                                          <td>:</td>
                                          <td>{{$zutil.dateformat(d.tarikh_hormon)}}</td>
                                       </tr>
                                       <tr class="row_data">
                                          <td><b>Kuantiti (ml)</b></td>  
                                          <td>:</td>
                                          <td>{{d.kuantiti_hormon}}</td>
                                       </tr>
                                       <tr class="row_data">
                                          <td><b>Harga (RM)</b></td>  
                                          <td>:</td>
                                          <td>RM. {{$zutil.currency(d.harga)}}</td>
                                       </tr>
                                    </template>
                                    <template v-else>
                                       <tr class="row_data">
                                          <td><b>Nama Hormon</b></td>  
                                          <td>:</td>
                                          <td>{{d.jenis_hormon}}</td>
                                       </tr>
                                       <tr class="row_data">
                                          <td><b>Tarikh Masuk Suntik</b></td>  
                                          <td>:</td>
                                          <td>{{$zutil.dateformat(d.tarikh_masuk_suntik)}}</td>
                                       </tr>
                                       <tr class="row_data">
                                          <td><b>Tarikh Keluar Suntik</b></td>  
                                          <td>:</td>
                                          <td>{{$zutil.dateformat(d.tarikh_keluar_suntik)}}</td>
                                       </tr>
                                       <tr class="row_data">
                                          <td><b>Harga (RM)</b></td>  
                                          <td>:</td>
                                          <td>RM. {{$zutil.currency(d.harga)}}</td>
                                       </tr>
                                    </template>
                                    </tbody>
                                 </table>
                              </div>
                           </div>
                        </div>
                     </w-flex>
                  </div>
                  <div v-else><center>Tiada data.</center></div>
               </template>
               <template v-if="dialog.tab==3">
                  <div class="w-flex wrap smd-column" >
                     <div class="grow " style="line-height: 35px">
                        <table >
                           <tbody>
                           <tr class="row_data">
                              <td>No Kes AI</td>  
                              <td>:</td>
                              <td>{{dialog.item.no_kes}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>Sumber Semen</td>  
                              <td>:</td>
                              <td>{{dialog.item.lkp_kategori_semen}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>Jenis Semen</td>  
                              <td>:</td>
                              <td>{{dialog.item.jenis_semen_ket}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>ID Ternakan | No Batch Semen</td>  
                              <td>:</td>
                              <td>
                                 <div v-if="!dialog.item.no_batch_keterangan">
                                    {{dialog.item.id_ternakan}} | {{dialog.item.no_batch}}
                                 </div>
                                 <div v-else>
                                    {{dialog.item.no_batch_keterangan  }}
                                 </div>
                              </td>
                           </tr>
                           <tr class="row_data">
                              <td>Harga Semen</td>  
                              <td>:</td>
                              <td>{{$zutil.formatDecimal(dialog.item.harga_straw)}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>No. Inseminasi</td>  
                              <td>:</td>
                              <td>{{dialog.item.bil_inseminasi}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>Bil. Straw Semen</td>  
                              <td>:</td>
                              <td>{{dialog.item.bil_straw}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>Tarikh Jangkaan PD</td>  
                              <td>:</td>
                              <td>{{$zutil.dateformat(dialog.item.jankaan_biang_semula)}}</td>
                           </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>  
               </template>
               <template v-if="dialog.tab==4">
                  <div class="w-flex wrap smd-column" >
                     <div class="grow " style="line-height: 35px">
                        <table >
                           <tbody>
                           <tr class="row_data">
                              <td>No Kes AI</td>  
                              <td>:</td>
                              <td>{{dialog.item.no_kes}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>Baka</td>  
                              <td>:</td>
                              <td>{{dialog.item.baka}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>Tarikh Beranak Terdahulu</td>  
                              <td>:</td>
                              <td>{{dialog.item.tarikh_beranak_terdahulu}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>Tarikh Suntikan Terdahulu/ Nama Juruteknik/ Jurusuntik</td>  
                              <td>:</td>
                              <td>-</td>
                           </tr>
                           <tr class="row_data">
                              <td>Kaedah Pemeriksaan</td>  
                              <td>:</td>
                              <td>{{dialog.item.lkpKaedahPemeriksaan_keterangan}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>Status</td>  
                              <td>:</td>
                              <td><div v-if="dialog.item.bunting_art==1">Bunting</div><div v-else>Tidak Bunting</div></td>
                           </tr>
                           <tr class="row_data">
                              <td>Usia Kebuntingan</td>  
                              <td>:</td>
                              <td>{{dialog.item.usia_bunting_art}}</td>
                           </tr>
                           <tr class="row_data">
                              <td>Tarikh Jangkaan Beranak</td>  
                              <td>:</td>
                              <td>{{$zutil.dateformat(dialog.item.jankaan_kelahiran_art)}}</td>
                           </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>  
               </template>
            <template #actions>
               <div class="spacer" />
                  <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
            </template>
         </w-dialog>
         <w-dialog
            v-model="dialogSemak.show"
            :fullscreen="dialogSemak.fullscreen"
            :width="dialogSemak.width"
            :persistent="dialogSemak.persistent"
            :persistent-no-animation="dialogSemak.persistentNoAnimation"
            title-class="primary-dark1--bg white">
            <template #title>
               <w-icon class="mr2">fal fa-list</w-icon>
               Semak Semula Perkhidmatan
            </template>
            <br>{{dialogSemak.form}}
            <w-form 
               ref="form" 
               v-model="dialogSemak.valid"
               @validate="sahkan(27)"
               @success="success"
             >
            <div class="w-flex wrap smd-column" >
                <w-textarea style="margin:5px;" label="Catatan *"  placeholder="Sila masukan.." class="mt4" outline  v-model="dialogSemak.item.catatan" :validators="[validators.required]"/>
            </div>
            </w-form>
            <template #actions>
               <div class="spacer" />
               <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogSemak.show = false">TUTUP</w-button>
               &nbsp;
               <w-button class="mr2" :loading="dialogSemak.loading" :disabled="dialogSemak.loading || dialogSemak.item.catatan == null" @click="sahkan(27)">
                  <w-icon m class="mr2">fal fa-paper-plane</w-icon>Hantar
               </w-button>
            </template>
         </w-dialog>
         <w-dialog
            v-model="dialogPd.show"
            :fullscreen="dialogPd.fullscreen"
            :width="dialogPd.width"
            :persistent="dialogPd.persistent"
            :persistent-no-animation="dialogPd.persistentNoAnimation"
            title-class="primary-dark1--bg white">
            <template #title>
               <w-icon class="mr2">fal fa-list</w-icon>
               Mohon PD
            </template>
            <z-select class="mt4"  outline :items="lkp_tujuan" label="Tujuan PD*" v-model="form_pd.lkp_tujuan_id" :validators="[validators.required]"/>
            <z-select class="mt4" outline :items="juruteknik_list" label="Nama Juruteknik/Jurusuntik *"  v-model="form_pd.juruteknik_pd_id"  :validators="[validators.required]" />
            <br>
            <div class="w-flex wrap smd-column" >
               <div class="grow ">
                  <table >
                     <tbody>
                     <tr class="row_data"><td>
                        <w-input type="date" label="Tarikh Jangkaan PD *" v-model="form_pd.jankaan_biang_semula" outline :validators="[validators.required]" readonly></w-input>
                     </td></tr>
                     </tbody>
                  </table>
               </div>
               <div class="grow ">
                  <table >
                     <tbody>
                     <tr class="row_data"><td>
                        <w-input type="date" label="Tarikh Temujanji PD *" v-model="form_pd.tarikh_datang_pemeriksaan" outline :validators="[validators.required]" ></w-input>
                     </td></tr>
                     </tbody>
                  </table>
               </div>
            </div>
            <template #actions>
               <div class="spacer" />
               <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogPd.show = false">TUTUP</w-button>
               <w-button class="mr2" bg-color="success" @click="hantarMohon(40)">
                  <w-icon m class="mr2">fal fa-paper-plane</w-icon>Mohon PD
               </w-button>
            </template>
         </w-dialog>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
// import Ternakan from './Show/Ternakan.vue';
import VueQrcode from 'vue-qrcode'
import ButiranKelahiran from './Sub/ButiranKelahiran.vue'

export default {
  extends: ZResource,
  components: {
    VueQrcode, ButiranKelahiran
  },
  props: {
    d_id: [Array, Object, String],

  },
  data() {
    return {
      resourceurl: 'art.permohonan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pembiakan Permohonan', route: '/art' },
        { label: 'Permohonan', route: '/art/permohonan' },
        { label: 'Papar', route: '/art/permohonan/'+this.id },
      ],

      title : '',
      id:this.d_id,
      data : {id : 0},
      activeTab : 0,
      activeTabModal: 0,
      ternakan_list:[],
      ibvk:{
        no_batch_keterangan:'',
        jumlah: '',
        harga:0.00,
        kuantiti: '',
        total_harga:''
      },
      negri:{
        no_batch_keterangan:'',
        jumlah: '',
        harga:0.00,
        kuantiti: '',
        total_harga:''
      },
      persendirian:{
        no_batch_keterangan:'',
        jumlah: '',
        harga:0.00,
        kuantiti: '',
        total_harga:''
      },
      dvs_negeri:{
        no_batch_keterangan:'',
        jumlah: '',
        harga:0.00,
        kuantiti: '',
        total_harga: ''
      },
      cidr:{
        jumlah: '',
        harga:0.00,
        kuantiti: ''
      },
      prid_delta:{
        jumlah: '',
        harga:0.00,
        kuantiti: ''
      },
      jumlah_persendirian:0,
      total_harga:0,
      totalAmaun:0,
      tarikh_sinkronisasi:null,
      isMinimizedList: false,
      isMinimizedCajSinkron: false,
      isMinimizedCaj: false,
      isMinimizedCajKeb: false,
      ternakan_sinkronisasi: [],
      tabsModal: [
            { title: 'MAKLUMAT PEMERIKSAAN TERNAKAN', content: '' },
            { title: 'MAKLUMAT HORMON', content: '' },
            // { title: 'MAKLUMAT PROSEDUR AI', content: ''},
            // { title: 'MAKLUMAT PEMERIKSAAN BUNTINGAN AI', content: ''},
      ],
      tabs: [
            { title: 'RUMUSAN PERKHIDMATAN', content: '' },
            // { title: 'BUTIRAN KELAHIRAN', content: ''},
            { title: 'AUDIT TRAIL', content: '', disabled:true},//disable dulu
            
          ],
      dialog: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 1500,
          tab: 0,
          item: []
        },
      dialogSemak: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 900,
         item: {
            catatan:null
         }
      },
      dialogPd: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 900,
          item: []
      },
      juruteknik_list: [],
      lkp_tujuan:[],
      persendirians:[],
      form_pd:{
         art_id: 0,
         lkp_tujuan_id: null,
         juruteknik_pd_id: 0,
         jankaan_biang_semula: null,
         tarikh_datang_pemeriksaan: null,
      },
      jankaan_biang_semula:null,
    }
  },
  methods: {
      validateForm() {
         this.loading=true;
         let isValid = true;
         let jumlah_lulus = 0;
         this.data.ternakan_list.forEach((row) => {
            if (row.pilih == true) {
               jumlah_lulus = 1;
            }
         })

         if (jumlah_lulus == 0) {
           this.$zutil.notify("Pastikan data sudah di Pilih", false);
           this.loading=false;
           return false;
         }

         this.MohonSemula()
      },

      MohonSemula(){
         this.$swal({
             title: 'Anda Pasti?',
             // text: "Are you sure want to delete this item!",
             type: 'warning',
             showCancelButton: true,
             confirmButtonColor: '#3085d6',
             cancelButtonColor: '#d33',
             confirmButtonText: 'Ya',
             cancelButtonText: 'Tidak'
            }).then((result) => {
            if (result.value) {
               if(this.data.id > 0){
               this.$zcomm.update('art.semakan.mohonSemulaAi', this.data.id, this.data)
                 .then(res => {
                     this.$inertia.visit(window.route('art.permohonan.sinkronisasi',0)+'?salin='+this.data.id);
                     this.loading = false;
                 })
                 .catch(err => {

                 })
                 .finally(() => {
                   
                 });
             }
           }else{ this.loading = false;}

           }) 
      },
   semaksemula(){
         this.dialogSemak.show = true;
      },
      mohonPd(dt, tab){
         this.form_pd.art_id = this.data.id;
         this.form_pd.lkp_tujuan_id = 5;
         this.form_pd.jankaan_biang_semula = this.jankaan_biang_semula ;
         this.form_pd.tarikh_datang_pemeriksaan = null; 
         this.dialogPd.show = true;
         this.getJuruteknik();
         this.getTujuanPd();
      },
      getJuruteknik(data){
         this.$zcomm.get(this.api_service + 'lookup/juruteknik/'+this.data.lkp_negeri_id+'/2/0', {}).then(res => {
            this.juruteknik_list = res
         });
      },
      getTujuanPd(){
         this.$zcomm.get(this.api_service + 'lookup/tujuan', {}).then(res => {
           this.lkp_tujuan = res
         })
      },
      hantarMohon(){
         let isValid = true;
         this.loading=true;
         if (!this.form_pd.juruteknik_pd_id || !this.form_pd.tarikh_datang_pemeriksaan) {
           isValid = false;
           this.loading=false;
         }
         if (!isValid) 
         {
           this.$zutil.notify("Pastikan semua data sudah diisi", false);
           this.loading=false;
           return false;
         }
         this.$swal({
             title: 'Anda Pasti?',
             // text: "Are you sure want to delete this item!",
             type: 'warning',
             showCancelButton: true,
             confirmButtonColor: '#3085d6',
             cancelButtonColor: '#d33',
             confirmButtonText: 'Ya',
             cancelButtonText: 'Tidak'
            }).then((result) => {
            if (result.value) {
               if(this.data.id > 0){
               this.$zcomm.update('art.semakan.et.mohonpd', this.data.id, this.form_pd)
                 .then(res => {
                     this.loading = false;
                     this.dialogPd.show = false;
                     this.$inertia.visit(window.route('art.semakan.index'));
                 })
                 .catch(err => {

                 })
                 .finally(() => {
                   
                 });
                 this.dialogPd.loading = false;
             }
           }else{ this.loading = false;}

           }) 
      },
      detail(data, tab){
         this.activeTabModal = 0;
         this.dialog.item = data;
         this.dialog.tab = tab ? tab : 0;
         this.dialog.show = true;
      },
    tutup(){
         this.$inertia.visit(window.route('art.semakan.index'));
       },

    cetak(data){
        // this.$inertia.visit(route("kursus.kursus.peserta.sijil_peserta", dt.peseta_user_id) +"?kursus_id="+dt.id,);
        window.open( window.route('art.permohonan.cetak', data), '_blank');
    },

    cetakCaj(data){
        window.open( window.route('art.cetak_caj', data+'?lkp_art='+4), '_blank');

    },

    sahkan(item) {
        this.loading = true;
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
        if (result.value) {
          if(this.data.id > 0){
            this.data.lkp_status_id = item;
            this.data.peternak = 1;
          this.$zcomm.update('art.semakan.sinkronisasi-aiman.update', this.data.id, this.data)
              .then(res => {
                console.log(res);
                  this.dialog.show = false;
                  this.$inertia.visit(window.route('art.semakan.index'));
              })
              .catch(err => {

              })
              .finally(() => {
              });
              this.dialog.loading = false;
          }
        }else{ this.loading = false;}

        }) 
      },
      kiraanProsedurSinkronisasi(){
         for (var c in this.ternakan_sinkronisasi){
           for (var d in this.ternakan_sinkronisasi[c].sinkronisasi){
            this.tarikh_sinkronisasi = this.ternakan_sinkronisasi[c].sinkronisasi[d].created_at;
            break;
           }
         }
      var cidr_kuantiti=0;
      var cidr_harga=0;
      var cidr_jumlah=0;
      var cidr_sinkronisasi_ya_tidak =0;

      var prid_delta_kuantiti=0;
      var prid_delta_harga=0;
      var prid_delta_jumlah=0;
      var prid_delta_sinkronisasi_ya_tidak =0;

      var total_harga = 0;
      var jumlah_persendirian = 0;

      var harga_persendirian_subsidi = 0;
      var harga_persendirian_bayar = 0;
      var jumlah_persendirian_subsidi = 0;
      var jumlah_persendirian_bayar = 0;
      var kuantiti_persendirian_bayar = 0;
      var kuantiti_persendirian_subsidi = 0;
      var sinkronisasi_ya_tidak_bayar = 0;
      var sinkronisasi_ya_tidak_subsidi = 0;

       for (var b in this.ternakan_sinkronisasi){
        for (var a in this.ternakan_sinkronisasi[b].sinkronisasi){
          if(this.ternakan_sinkronisasi[b].sinkronisasi[a].lkp_jenis_hormon_id == 1){
            cidr_kuantiti=cidr_kuantiti+1;
            cidr_harga = this.ternakan_sinkronisasi[b].sinkronisasi[a].harga;
            cidr_sinkronisasi_ya_tidak = this.ternakan_sinkronisasi[b].sinkronisasi[a].sinkronisasi_ya_tidak;
          }
          if(this.ternakan_sinkronisasi[b].sinkronisasi[a].lkp_jenis_hormon_id == 2){
            prid_delta_kuantiti= prid_delta_kuantiti+1;
            prid_delta_harga = this.ternakan_sinkronisasi[b].sinkronisasi[a].harga;
            prid_delta_sinkronisasi_ya_tidak = this.ternakan_sinkronisasi[b].sinkronisasi[a].sinkronisasi_ya_tidak;
          }
          if(this.ternakan_sinkronisasi[b].sinkronisasi[a].lkp_jenis_hormon_id == 3){

           if(this.ternakan_sinkronisasi[b].sinkronisasi[a].sinkronisasi_ya_tidak == 2){
               jumlah_persendirian_subsidi = jumlah_persendirian_subsidi+ Number(this.ternakan_sinkronisasi[b].sinkronisasi[a].harga);
               harga_persendirian_subsidi = harga_persendirian_subsidi+ Number(this.ternakan_sinkronisasi[b].sinkronisasi[a].harga);
               kuantiti_persendirian_subsidi = this.ternakan_sinkronisasi[b].sinkronisasi[a].kuantiti_hormon;
               sinkronisasi_ya_tidak_subsidi = this.ternakan_sinkronisasi[b].sinkronisasi[a].sinkronisasi_ya_tidak;
            }else{
               jumlah_persendirian_bayar = jumlah_persendirian_bayar+ Number(this.ternakan_sinkronisasi[b].sinkronisasi[a].harga); 
                harga_persendirian_bayar = harga_persendirian_bayar+ Number(this.ternakan_sinkronisasi[b].sinkronisasi[a].harga);
               kuantiti_persendirian_bayar = this.ternakan_sinkronisasi[b].sinkronisasi[a].kuantiti_hormon;
               sinkronisasi_ya_tidak_bayar = this.ternakan_sinkronisasi[b].sinkronisasi[a].sinkronisasi_ya_tidak;
            }
            
            jumlah_persendirian = jumlah_persendirian+ Number(this.ternakan_sinkronisasi[b].sinkronisasi[a].harga);
          }

        }
       }
      this.cidr.jumlah = cidr_harga * cidr_kuantiti;
      this.cidr.harga = cidr_harga;
      this.cidr.kuantiti = cidr_kuantiti;
      this.cidr.sinkronisasi_ya_tidak = cidr_sinkronisasi_ya_tidak;

      this.prid_delta.jumlah = prid_delta_harga * prid_delta_kuantiti;
      this.prid_delta.harga = prid_delta_harga;
      this.prid_delta.kuantiti = prid_delta_kuantiti;
      this.prid_delta.sinkronisasi_ya_tidak = prid_delta_sinkronisasi_ya_tidak;

      this.jumlah_persendirian = jumlah_persendirian;

      this.jumlah_persendirian_subsidi = jumlah_persendirian_subsidi;
      this.harga_persendirian_subsidi = harga_persendirian_subsidi;
      this.kuantiti_persendirian_subsidi = kuantiti_persendirian_subsidi;
      this.sinkronisasi_ya_tidak_subsidi = sinkronisasi_ya_tidak_subsidi;

      this.jumlah_persendirian_bayar = jumlah_persendirian_bayar;
      this.harga_persendirian_bayar = harga_persendirian_bayar;
      this.kuantiti_persendirian_bayar = kuantiti_persendirian_bayar;
      this.sinkronisasi_ya_tidak_bayar = sinkronisasi_ya_tidak_bayar;

      this.data.keseluruhan_sinkronisasi = Number(this.data.pengangkutan_sinkronisasi) + Number(this.data.konsutasi_sinkronisasi) + Number(this.data.caj_lain_sinkronisa) + this.cidr.jumlah +  this.prid_delta.jumlah + this.jumlah_persendirian;

      if(this.data.jenis_pengguna_pemohon == 1){//caj kerajaan
        if(this.data.konsutasi_sinkronisasi_ya_tidak==2){ 
          total_harga =  this.cidr.jumlah +  this.prid_delta.jumlah + this.jumlah_persendirian + Number(this.data.konsutasi_sinkronisasi) + Number(this.data.caj_lain_sinkronisa) + Number(this.data.pengangkutan_sinkronisasi);
          this.total_harga = total_harga;
          this.data.subsidi_sinkronisasi = total_harga;
        }else{
          total_harga =  this.cidr.jumlah +  this.prid_delta.jumlah + this.jumlah_persendirian + Number(this.data.caj_lain_sinkronisa) + Number(this.data.pengangkutan_sinkronisasi);
          this.total_harga = total_harga;
          this.data.subsidi_sinkronisasi = total_harga;
        }
        this.data.perlu_bayar_sinkronisasi = Number(this.data.keseluruhan_sinkronisasi) - Number(this.data.subsidi_sinkronisasi);
      }else{//caj swasta
            if(this.datas.konsutasi_sinkronisasi_ya_tidak==2){ 
                total_harga =  Number(this.datas.konsutasi_sinkronisasi);
                this.total_harga = total_harga;
                // total_harga =  this.cidr.jumlah + this.prid_delta.jumlah + this.jumlah_persendirian + Number(this.datas.konsutasi_sinkronisasi);
                // this.total_harga = total_harga;
                // this.datas.subsidi_sinkronisasi = total_harga;
            }else{
                total_harga =  0;
                this.total_harga = total_harga;
                // total_harga =  this.cidr.jumlah +  this.prid_delta.jumlah + this.jumlah_persendirian;
                // this.total_harga = total_harga;
                // this.datas.subsidi_sinkronisasi = total_harga;
            }

            if(this.cidr.sinkronisasi_ya_tidak ==2){ 
                var subsidi_cidr =  Number(this.cidr.jumlah) ;
            }else{
                var subsidi_cidr = 0;
            }

            if(this.prid_delta.sinkronisasi_ya_tidak ==2){ 
                var subsidi_prid_delta =  Number(this.prid_delta.jumlah) ;
            }else{
                var subsidi_prid_delta = 0;
            }

         

            if(this.datas.bayar_pengangkutan==2){ 
                var pengangkutan_sinkronisasi =  Number(this.datas.pengangkutan_sinkronisasi) ;
            }else{
                var pengangkutan_sinkronisasi = 0;
            }

            if(this.datas.bayar_caj_lain==2){ 
                var caj_lain_sinkronisa =  Number(this.datas.caj_lain_sinkronisa) ;
            }else{
                var caj_lain_sinkronisa = 0;
            }

            // this.subsidi_hormon = subsidi_hormon;
            // this.datas.keseluruhan_sinkronisasi = Number(this.datas.pengangkutan_sinkronisasi) + Number(this.datas.konsutasi_sinkronisasi) + total_harga ;
            // this.datas.perlu_bayar_sinkronisasi = Number(this.datas.pengangkutan_sinkronisasi) + Number(this.datas.konsutasi_sinkronisasi);
            this.datas.subsidi_sinkronisasi = this.total_harga + pengangkutan_sinkronisasi + caj_lain_sinkronisa + subsidi_cidr + subsidi_prid_delta + harga_persendirian_subsidi;

            this.datas.perlu_bayar_sinkronisasi = this.datas.keseluruhan_sinkronisasi - this.datas.subsidi_sinkronisasi;
        }
      },
      kiraanProsedurAi(){
         for (var b in this.data.ternakan_list){
            if (this.data.ternakan_list[b].se_stock_id!=null) {
               this.jankaan_biang_semula = this.data.ternakan_list[b].jankaan_biang_semula;
               break;
            }
         }
         var total_harga = 0;

          // alert('df');
         let ibvk = [];
         ibvk = this.data.ternakan_list
            .filter((item) => item.lkp_kategori_semen_id == 1)
            .map((item) => ({
              no_batch_keterangan: item.no_batch_keterangan,
              kuantiti: item.bil_straw,
              harga: parseFloat(item.harga_straw),
              total_harga: parseFloat(item.harga_straw) * item.bil_straw,
         }));

         let negri = [];
         negri = this.data.ternakan_list
            .filter((item) => item.lkp_kategori_semen_id == 2)
            .map((item) => ({
              no_batch_keterangan: item.no_batch_keterangan,
              kuantiti: item.bil_straw,
              harga: parseFloat(item.harga_straw),
              total_harga: parseFloat(item.harga_straw) * item.bil_straw,
         }));

         let persendirian = [];
         persendirian = this.data.ternakan_list
            .filter((item) => item.lkp_kategori_semen_id == 3)
            .map((item) => ({
               no_batch_keterangan: item.no_batch_keterangan,
              kuantiti: item.bil_straw,
              harga: parseFloat(item.harga_straw),
              total_harga: parseFloat(item.harga_straw) * item.bil_straw,
         }));
         const groupBy = (key) => persendirian.sort((a, b) => a[key].localeCompare(b[key])).reduce((total, currentValue) => {
           const newTotal = total;
           if (
             total.length &&
             total[total.length - 1][key] === currentValue[key]
           )
             newTotal[total.length - 1] = {
               ...total[total.length - 1],
               ...currentValue,
               // harga: parseInt(total[total.length - 1].harga) + parseInt(currentValue.harga),
               total_harga: parseInt(total[total.length - 1].total_harga) + parseInt(currentValue.total_harga),
               kuantiti: parseInt(total[total.length - 1].kuantiti) + parseInt(currentValue.kuantiti),
             };
           else newTotal[total.length] = currentValue;
           return newTotal;  
         }, []);

         this.persendirians = groupBy('no_batch_keterangan');

         const totalIbvk = ibvk.reduce((accumulator, item) => accumulator + item.total_harga, 0);
         const totalNegri = negri.reduce((accumulator, item) => accumulator + item.total_harga, 0);
         const totalPersendirian = persendirian.reduce((accumulator, item) => accumulator + item.total_harga, 0);

       // Output
       console.log('No Batch List:', ibvk);

         // this.total_harga = total_harga.toFixed(2);
         var no_batch_keterangan = [];
         for (var b in this.ternakan_list){
           if (this.ternakan_list[b].lkp_kategori_semen_id==1) {
             no_batch_keterangan= this.ternakan_list[b].no_batch_keterangan
           }
         }
         this.ibvk = ibvk;
         this.negri = negri;
         this.persendirian = persendirian;
         this.data.keseluruhan = Number(this.data.pengangkutan) + Number(this.data.konsutasi) + Number(this.data.caj_lain) + Number(totalIbvk) + Number(totalNegri) + Number(totalPersendirian);
         if(this.data.jenis_pengguna_pemohon == 1){
            if(this.data.konsutasi_ya_tidak==2){ 
               var subsidi = Number(totalIbvk) + Number(totalNegri) + Number(this.data.pengangkutan) + Number(this.data.konsutasi) + Number(this.data.caj_lain);
            }else{
               var subsidi = Number(totalIbvk) + Number(totalNegri) + Number(this.data.pengangkutan) + Number(this.data.caj_lain);
            }
            this.data.subsidi = subsidi;
            this.data.perlu_bayar = this.data.keseluruhan - subsidi;
         }else{
            if(this.data.konsutasi_ya_tidak==2){ 
               var subsidi = Number(totalIbvk) + Number(this.data.konsutasi) + Number(totalNegri);
               // var perlu_bayar = Number(totalPersendirian) + Number(this.data.caj_lain)+ Number(this.data.pengangkutan);
            }else{
               var subsidi = Number(totalIbvk) + Number(totalNegri);
               // var perlu_bayar = Number(this.data.konsutasi) + Number(totalPersendirian) + Number(this.data.caj_lain)+ Number(this.data.pengangkutan);
            }
            this.data.subsidi = subsidi;
            this.data.perlu_bayar = this.data.keseluruhan - subsidi ;
         }
      },


  
    getData()
    {
      this.ternakan_sinkronisasi = [];
      this.$zcomm.get(this.api_service + 'art/show/'+this.id, {}).then(res => {
         for (var b in res.ternakan_list) {
          if(res.ternakan_list[b].bunting==2 && res.ternakan_list[b].status_pemeriksaan ==1){
            // this.getHarga(this.data.ternakan_list[b]);
            this.ternakan_sinkronisasi.push({
              id : res.ternakan_list[b].id,
              art_id : res.ternakan_list[b].art_id,
              harga :res.ternakan_list[b].harga_sinkronisasi,
              ternakan_nama : res.ternakan_list[b].ternakan_nama,
              sinkronisasi : res.ternakan_list[b].sinkronisasi
            })
          }
        }
        this.data = res

         this.kiraanProsedurAi();
         this.kiraanProsedurSinkronisasi();
        // if (this.data) {}
      // if(this.$zutil.role('1')){
      //     this.tabs = [
      //       // { title: 'Baka', content: '' },
      //       { title: 'Ternakan', content: '' },
            
      //     ]
      //   }
      //   else
      //   {
      //     this.tabs = [
      //       { title: 'Ternakan', content: '' },
           
      //     ]
      //   }
         // if(this.data.lkp_status_id==40||this.data.lkp_status_id==18){
         //    this.tabs[1].disabled = false;
         // }else{
         //    this.tabs[1].disabled = true;
         // }
       if(this.data.lkp_art_id == 1)
        {
          this.title = 'RUMUSAN PERKHIDMATAN AI'
        }
        if(this.data.lkp_art_id == 2)
        {
          this.title = 'RUMUSAN PEMERIKSAAN KEBUNTINGAN'
        }
        if(this.data.lkp_art_id == 3)
        {
          this.title = 'RUMUSAN PERKHIDMATAN ET'
        }

      })
    },

    
   

  },
  watch: {

  },
  mounted() {
    this.getData();
    
    
  },
}
</script>



